import React from 'react'
import { StyleProp, TouchableOpacity, ViewStyle } from 'react-native'
import Icon, { IconProps } from 'APP/Converse/Icon'
import Typography from 'APP/Converse/Typography'
import { useTheme } from 'styled-components/native'

import { Container, TitleContainer, CloseButton, SecondaryTextContainer, Link } from './style'
import I18n from 'APP/I18n'

import Analytics from 'APP/Services/Analytics'

interface AlertModalProps {
  titleText: string
  subtitleText: string
  linkText: string
  icon: string
  iconColor: string
  alertStyle: string | number
  style: StyleProp<ViewStyle>
  handleDismissModal: () => void
  handleLinkAction: () => void
}

const AlertModal: React.FC<Partial<AlertModalProps>> = ({
  titleText,
  subtitleText,
  linkText,
  icon,
  iconColor,
  alertStyle,
  style,
  handleDismissModal,
  handleLinkAction,
}) => {
  const theme = useTheme()

  const _handleDismissModal = () => {
    Analytics.trackEvent('button_click', { button_value: 'Dismiss' }, ['banner_context'])
    handleDismissModal?.()
  }

  const _handleLinkAction = (linkText: string | undefined) => {
    handleLinkAction?.()
    return () => {
      Analytics.trackEvent(
        'link_text_click',
        {
          linkText: linkText,
        },
        ['banner_context']
      )
    }
  }

  const backgroundColor = theme.colors.bannerBg
  const titleColor = theme.colors[`alertBannerTitle${alertStyle}` as keyof typeof theme.colors]

  return (
    <Container style={[backgroundColor && { backgroundColor }, style]} accessible>
      <CloseButton
        onPress={_handleDismissModal}
        accessibilityLabel={I18n.t('AccessibilityIcons.close')}
      >
        <Icon src="close" variant="materialIcons" size={theme.fonts.fontSize.h2} color="text" />
      </CloseButton>
      <TitleContainer>
        <Typography
          variant="h3"
          color={titleColor}
          style={{ display: 'flex', justifyContent: 'center' }}
        >
          {icon && (
            <Icon
              src={icon}
              variant="ionicons"
              color={iconColor as IconProps['color']}
              size={theme.fonts.fontSize.large}
              testID="ICON"
            />
          )}
          {icon && ' '}
          {titleText}
        </Typography>
      </TitleContainer>
      <SecondaryTextContainer>
        <Typography variant="bodyNormal" style={{ textAlign: 'center' }}>
          {subtitleText}
        </Typography>
        <TouchableOpacity onPress={() => _handleLinkAction(linkText)}>
          <Link variant="subheaderBold">{linkText}</Link>
        </TouchableOpacity>
      </SecondaryTextContainer>
    </Container>
  )
}

export default AlertModal
